<!--
 * @message:
 * @Author: cjc
 * @since: 2019-11-26 12:10:14
 * @lastTime: 2019-12-17 17:43:50
 * @LastAuthor: cjc
 -->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  color: #fff;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/App.vue